import constant from './constant';
//  获取uri里面的参数对应的值
function get_querystring(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return unescape(r[2]);
    }
    return null;
}
// 排序算法
function shuffle(array){
    var i,x,j;
    for(i=array.length;i>0;i--){
        j = Math.floor(Math.random()*i);
        x = array[j];
        array[j] = array[i-1];
        array[i-1] = x;
    }
    return array;
}
// 过滤url中的http/https字符串
function filter_domain(str) {
    let result = str.match(/^((http:\/\/)|(https:\/\/))?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/);
    if (result[0] == 'https://download.ydstatic.com') {
        result = str.split('?')
    }
    if (result) {
        return result[0];
    } else {
        return str;
    }
}
// 获取数组的随机idx
function get_random(arr) {
    let len = arr.length;
    let ran = Math.floor((Math.random()*len));
    return arr[ran];
}
// 检测协议是不是https
function check_protocal() {
    let protocal = location.protocol;
    if (protocal == 'http:') {
        return false;
    } else {
        return true;
    }
}
// 返回图片地址
function get_img(url) {
    return `${constant.IMG_DATA_URL}/${url}`;
}
// 组装参数
function get_params(pre, option) {
    let queryStringList = [];
    for (let i in option) {
        queryStringList.push(`${i}=${option[i]}`);
    }
    return `${pre}?${queryStringList.join('&')}`;
}
export default { 
    get_querystring, 
    shuffle,
    filter_domain,
    get_random,
    check_protocal,
    get_img,
    get_params
}


// WEBPACK FOOTER //
// ./src/util/util.js